<template>
	<div class="doctors">
		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("admin.doctors")}}</div>
			</md-card-header>
		</md-card>

		<md-card v-for="(doctor, index) in doctors">
			<md-card-header>
				<div class="md-title">{{doctor.name}}</div>
				<div class="md-subhead">{{doctor.doctorData.speciality}}</div>
			</md-card-header>
			<md-card-content class="row">
				<div class="col-md-6 col-xs-12">
					<b>Páciensek száma:</b> {{doctor.patientCount}}
				</div>
				<div class="col-md-6 col-xs-12">
					<b>Bejelentkezési e-mail:</b> {{doctor.email}}
				</div>
				<div class="col-md-6 col-xs-12">
					<b>Adatbázis azonosító:</b> {{doctor._id}}
				</div>

				<div class="col-xs-12">
					<b>Bemutatkozás:</b></br>
					{{doctor.doctorData.introduction}}
				</div>
				
				<div class="col-xs-12 contentWrapper">
					<h4>Publikus kapcsolati adatok:</h4>
						<div v-for="contact in doctor.doctorData.contact">
							<b>{{contact.name}}:</b> {{contact.value}}
						</div>
				</div>

				<div class="col-xs-12 contentWrapper">
					<h4>Statisztikák:</h4>
					<div v-for="activity in doctor.activity">
						<div v-if="activity.type == 'INID.activity.globalViewed'">
							<b>Legutolsó belépés:</b> {{simpleDate(activity.events[activity.events.length-1])}}
						</div>
						<div v-if="activity.type == 'INID.activity.patientsViewed'">
							<b>Páciens lista megtekintve:</b> {{simpleDate(activity.events[activity.events.length-1])}}
						</div>
					</div>
				</div>
				
			</md-card-content>
		</md-card>

	</div>
</template>

<script>
	import Api from '../../../generated'
	import moment from 'moment'
	import _ from 'lodash'

	export default {
		data(){
			return {
				doctors: []
			}
		},
		mounted(){
			this.$bus.$emit('showLoading', true);

			Api.ApiClient.instance.listDoctors((error, data, response) => {
				if (error) {
					console.error(error);
				} else {
					console.log(data);
					this.doctors = data;
				}
				this.$bus.$emit('showLoading', false);
			})
		},
		methods: {
			simpleDate(date){
				return moment(date).format("YYYY.MM.DD - HH:mm");
			}
		}
	}
</script>

<style scoped>
	.avatar{
		width: 30px;
		height: 30px;
	}
	.contentWrapper{
		background-color: #eee;
		padding: 8px;
		margin-bottom: 16px;
	}
	.contentWrapper h4{
		font-size: 12pt;
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// DoctorList.vue?5e9b8b15